import { Stack, styled } from "@mui/material";
const ValidationSummaryRowContainer = styled(Stack, {
  name: "ValidationSummaryRowContainer",
  slot: "Root",
  skipSx: true,
  shouldForwardProp: (prop) => prop !== "alignItems"
})(({ alignItems = "flex-start" }) => ({
  alignItems,
  flexDirection: "row"
}));
export {
  ValidationSummaryRowContainer
};
//# sourceMappingURL=ValidationSummaryRowContainer.js.map
